import React from 'react';
import { Button, ButtonProps } from 'antd';

/**
 * The rounded "Edit"/"Change" pill button used everywhere in the
 * redesigned Settings page instead of an underlined text link -- just a
 * thin, consistently-styled wrapper around antd's own Button so every
 * call site doesn't repeat the same shape/size props.
 */
const SettingsPillButton: React.FC<ButtonProps> = ({ style, ...props }) => (
  <Button shape="round" size="small" style={{ fontSize: 13, padding: '4px 18px', height: 'auto', ...style }} {...props} />
);

export default SettingsPillButton;
